import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const CompletionReportBlockSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className={style.block}>
      <div className={style.blockHead}>
        <div className={style.blockTitle}>{t('Completion reports')}</div>
      </div>
      <div className={style.blockContainer}>
        <div className={style.tableWrapper}>
          <table className={style.reportsTable} cellSpacing="0" cellPadding="0">
            <thead className={style.reportsTableHead}>
              <tr>
                <th className={style.reportsTableTh}></th>
                <th className={style.reportsTableTh}>{t('Report date')}</th>
                <th className={style.reportsTableTh}>{t('Status')}</th>
                <th className={style.reportsTableTh}>{t('Submitted by')}</th>
                <th className={style.reportsTableTh}></th>
              </tr>
            </thead>
            <tbody className={style.reportsTableBody}>
              {[...Array(5)].map((_) => (
                <tr key={uuidv4()} className={style.reportsTableBodyRow}>
                  <td className={style.reportsTableTd}>
                    <SkeletonBlock className={style.skeletonSensorsTableItem} />
                  </td>
                  <td className={style.reportsTableTd}>
                    <SkeletonBlock className={style.skeletonSensorsTableItem} />
                  </td>
                  <td className={style.reportsTableTd}>
                    <SkeletonBlock className={style.skeletonSensorsTableItem} />
                  </td>
                  <td className={style.reportsTableTd}>
                    <SkeletonBlock className={style.skeletonSensorsTableItem} />
                  </td>
                  <td className={cx(style.reportsTableTd, style.cellAlignRight)}>
                    <SkeletonBlock className={style.skeletonSensorsTableItem} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CompletionReportBlockSkeleton;
